import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import qs from 'query-string';
import SupplierAutosuggest from 'components/SupplierAutosuggest';

const Filter = props => {
  const [supplierId, setSupplierId] = useState<string>('');
  const [supplier, setSupplier] = useState<Record<string, any>>({});

  useEffect(() => {
    const {
      objectId,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });
    setSupplierId(objectId?.toString() || '');
  }, []);


  const resetFilter = () => {
    setSupplierId('');
    setSupplier({});
    const filterData = {};
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    const filterData = {
      objectId: supplierId || supplier.id,
    };
    props.onSubmit(filterData);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['autosuggest-group']}>
        <div className={styles['label']}>Supplier</div>
        <SupplierAutosuggest
          supplierName={supplier.full_name || ''}
          // eslint-disable-next-line @typescript-eslint/camelcase
          setSupplierName={val => setSupplier({ ...supplier, full_name: val  })}
          setSupplier={setSupplier}
          setSupplierId={setSupplierId}
        />
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;